import React from 'react';
import BasicInfoTab from './tabs/BasicInfoTab';
import LocationTab from './tabs/LocationTab';
import OperationsTab from './tabs/OperationsTab';
import PaymentTab from './tabs/PaymentTab';
import DeliveryTab from './tabs/DeliveryTab';
import BrandingTab from './tabs/BrandingTab';

export default function SettingsContent({
  activeTab,
  formData,
  restaurant,
  allDeliverySlots,
  selectedDeliverySlots,
  onInputChange,
  onWorkingDayToggle,
  onDeliverySlotToggle,
  onTagAdd,
  onTagRemove,
  constants
}) {
  const commonProps = {
    formData,
    restaurant,
    onInputChange,
    constants
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'basic':
        return (
          <BasicInfoTab 
            {...commonProps}
            onTagAdd={onTagAdd}
            onTagRemove={onTagRemove}
          />
        );
      case 'location':
        return <LocationTab {...commonProps} />;
      case 'operations':
        return (
          <OperationsTab 
            {...commonProps}
            onWorkingDayToggle={onWorkingDayToggle}
          />
        );
      case 'payment':
        return <PaymentTab {...commonProps} />;
      case 'delivery':
        return (
          <DeliveryTab 
            {...commonProps}
            allDeliverySlots={allDeliverySlots}
            selectedDeliverySlots={selectedDeliverySlots}
            onDeliverySlotToggle={onDeliverySlotToggle}
          />
        );
      case 'branding':
        return <BrandingTab {...commonProps} />;
      default:
        return <BasicInfoTab {...commonProps} />;
    }
  };

  return (
    <div className="animate-fade-in">
      {renderTabContent()}
    </div>
  );
}
